<template>

<aside class="main-sidebar sidebar-dark-primary elevation-4" >
      <!-- Brand Logo -->
      <a href="/" class="brand-link">
        <img src="static/img/AdminLTELogo.png" alt="爱学充电" class="brand-image img-circle elevation-3"
            style="opacity: .8">
        <span class="brand-text font-weight-light">爱学充电</span>
      </a>

      <!-- Sidebar -->
      <div class="sidebar">

        <!-- Sidebar Menu -->
        <nav class="mt-2">
          <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            
            <!-- 添加class： menu-open 菜单展开 -->
            <li class="nav-item" :class="item.isOpen?'menu-open':''" v-for="(item,index) in menuTrue" v-bind:key="index">
              <a :href="'#' + item.href" class="nav-link nav-parent" :class="[$route.path == item.href?'active':'']">
                <i class="nav-icon fas" :class="item.icon"></i>
                <p>{{item.title}} <i class="right fas fa-angle-left" v-show="item.children && item.children.length>0"></i> </p>
              </a>

              <ul class="nav nav-treeview" v-show="item.children && item.children.length>0">
                <li class="nav-item" v-for="(childItem, childIndex) in item.children" :key="childIndex">
                  <a :href="'#' + childItem.href" class="nav-link" :class="[$route.path == childItem.href?'active':'']">
                    <i class="far fa nav-icon" :class="childItem.icon"></i>
                    <p>{{childItem.title}}</p>
                  </a>
                </li>
              </ul>
            </li>

          </ul>
        </nav>
        <!-- /.sidebar-menu -->
      </div>
      <!-- /.sidebar -->
    </aside>
  

</template>

<script>
// import { menu } from "@/api/data.js";
// import { filterMenu } from "@/util/util.js";
import { mapState  } from "vuex";
import { fetchGet, fetchPost } from "@/api/axios_config.js";
import { api, buff } from "@/api/api.js";

export default {
  name: 'Sidebar',
  data () {
    return {
      list : [],
      cHeight : '0px'
    }
  },
  computed:{

    ...mapState("userModule", ["roleId"]),

    menuTrue : function(){
      let that = this;
      let result = this.list;
     
      return result.map(item => {
        return {
          ...item,
          isOpen: function(){
            let m = false;
            m = item.href == that.$route.path ? true : false;
            if(item.children){
              item.children.forEach(child => {
                if(child.href === that.$route.path){
                  m = true;
                }
              });
            }
            return m;
          }()
        };
      });
    }
  },
  methods:{

    async getAllMenu(){
      
      if(!this.roleId){
        this.$toast('数据错误');
        return false;
      }
      let res = await fetchGet(api.getMenuByRoleId, {roleId:this.roleId});

      this.list = res.data;
    }
  },
  created(){
    this.getAllMenu()
  },
  mounted(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-sidebar>.nav-item .nav-icon.fa, .nav-sidebar>.nav-item .nav-icon.fab, .nav-sidebar>.nav-item .nav-icon.far, .nav-sidebar>.nav-item .nav-icon.fas, .nav-sidebar>.nav-item .nav-icon.glyphicon, .nav-sidebar>.nav-item .nav-icon.ion{font-size: .8rem;}
.sidebar{padding-left: 0;padding-right: 0;}
.nav-pills .nav-link{border-radius: 0;}
.main-sidebar, .main-sidebar::before{width: 200px;}
.nav-parent{background-color: #495057;}
[class*=sidebar-dark-] .nav-treeview>.nav-item>.nav-link.active, [class*=sidebar-dark-] .nav-treeview>.nav-item>.nav-link.active:focus, [class*=sidebar-dark-] .nav-treeview>.nav-item>.nav-link.active:hover{background-color: #007bff;color: #e9ecef;}
.elevation-4 {
    box-shadow: 0 1px 1px rgba(0,0,0,.25),0 1px 5px rgba(0,0,0,.22)!important;
}
.elevation-3 {
    box-shadow: 0 1px 1px rgba(0,0,0,.25),0 1px 5px rgba(0,0,0,.22)!important;
}
[class*=sidebar-light-] {
    background-color: #f8f9fa;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue